import type { FC, ReactNode } from 'react'
import type { BlobShape } from '@/lib/shapes'

import { cn } from '@/lib/utils'
import { Blob } from '@/components/generals/blob'

interface StickerProps {
    label: string
    shape?: BlobShape
    colorClassName?: string
    className?: string
    labelClassName?: string
    decorative?: boolean
}

// A playful label printed on a die-cut shape. Size it with `className`
// (for example `size-24 text-lg`) and tilt it with a rotate utility.
export const Sticker: FC<StickerProps> = ({
    label,
    shape = 'flower',
    colorClassName = 'text-mint',
    className,
    labelClassName,
    decorative = true
}): ReactNode => {
    return (
        <span
            aria-hidden={decorative ? 'true' : undefined}
            className={cn('pointer-events-none relative inline-grid size-24 shrink-0 select-none place-items-center text-lg', className)}
        >
            <Blob
                shape={shape}
                className={cn('absolute inset-0 size-full drop-shadow-[0_3px_0_rgba(60,13,37,0.25)]', colorClassName)}
            />

            <span className={cn('relative px-2 text-center font-heading leading-[0.95] tracking-wide text-plum', labelClassName)}>
                {label}
            </span>
        </span>
    )
}
